import React, { useEffect, useState } from 'react'
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material'
import HCarosel from '../Component/Carosel/Carosel'
import MissionVission from './MV/MV'
import HS from './HS/HS'
import Events from './Events/Events'
import ServicesCarosel from '../Component/Carosel/Services_Carosel'
import CourseOffering from './Course_Offering/Course_Offering'
import TestimonialVideo from './../Component/Testimonial_component/TestimonialVideo'
import StudyWithUs from './Study_with_us/Study_with_us'
import WelcomeModal from '../Component/Welcomemodel'
import { useActivity } from '../Component/context_components/activities_context'
import { fetchData } from '../Assets/API/apiservices'
import { ORGANIZATION_ID, SUB_ORGANIZATION_ID } from '../Config/Config'

const Home = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const { activitiesData, loading, setActivityId } = useActivity()
  const [mvDATA, setmvData] = useState()
  const [testimonialsData, settestimonialsData] = useState()
  const [welcomeModalOpen, setWelcomeModalOpen] = useState(true)

  useEffect(() => {
    if (setActivityId) setActivityId(2)
  }, [setActivityId])

  const getMVData = async () => {
    try {
      const response = await fetchData(
        `visions?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
      )
      setmvData(response?.rows || [])
    } catch (error) {
      console.error('Error fetching MV data', error)
    }
  }

  const getTestimonialsData = async () => {
    try {
      const response = await fetchData(
        `testimonials?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
      )
      settestimonialsData(response?.rows || [])
    } catch (error) {
      console.error('Error fetching testimonials data', error)
    }
  }

  useEffect(() => {
    getMVData()
    getTestimonialsData()
  }, [])

  const HSData = {
    title: 'How we Started',
    image:
      'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/home/howwestarted/howwestarted.jpg',
    description:
      'Dr.B.R. Ambedkar Educational Institutions was started by Late. Sri G Venkataswamy Garu, former Union Minister, Govt. of India in the year 1973. These institutions are inaugurated by Sri V.V. Giri, by then Hon. President of India. Dr.B.R. Ambedkar Educational Institutions is nestled up throughout a 3 acre land in Baghlingampally, Hyderabad. Being in the heart of the city, it boasts of a huge campus, excellent infrastructure facilities and dedicated management and staff. The institutions group includes High School, Junior College, Degree College, Post-Graduate College, Law College and MBA College. Approximately, 3000 students in total are presently studying in the institutions. Apart from the academics, Dr. B.R. Ambedkar educational institutions excels in extra curricular activities too. We have one of the best National Cadet Corps (NCC) team,  3 NSS units. We have partnered with the esteemed Spotlight Cricket Academy which provides excellent cricket coaching for the age group 6 to 18 years.Dr.B.R. Ambedkar Degree College was started in the year 1973. It was granted Aid in the year 1977. Around 1100 students are studying in the degree college which offers courses including B.Com (general), B.com (computers),  BSc (MPC),  BSc (computers), B.Sc (electronics), BBA,  BA (Journalism) and  BA (EPP).',
  }

  useEffect(() => {
    const isModalShown = sessionStorage.getItem('welcomeModalShown')
    if (!isModalShown) {
      setWelcomeModalOpen(true)
      sessionStorage.setItem('welcomeModalShown', 'true')
    }
  }, [])

  const handleCloseWelcomeModal = () => {
    setWelcomeModalOpen(false)
  }

  return (
    <Box component="section" sx={{ overflowX: 'hidden' }}>
      {loading ? (
        <Typography
          variant="h6"
          align="center"
          sx={{
            mt: 4,
            fontSize: isMobile ? '1.1rem' : '1.25rem',
          }}
        >
          Loading...
        </Typography>
      ) : (
        <>
          {welcomeModalOpen && (
            <WelcomeModal
              open={welcomeModalOpen}
              onClose={handleCloseWelcomeModal}
              fullScreen={isMobile}
            />
          )}
          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <HCarosel />
            <StudyWithUs />
          </Box>

          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <CourseOffering />
          </Box>

          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <MissionVission MV_DATA={mvDATA} />
          </Box>

          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <HS HS_DATA={HSData || {}} />
          </Box>

          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <TestimonialVideo
              videos={testimonialsData}
              title={'Student Testimonials'}
            />
          </Box>

          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <ServicesCarosel />
          </Box>

          <Box
            sx={{
              mb: isMobile ? 4 : 8,
              px: isMobile ? 2 : 0,
            }}
          >
            <Events
              Event_DATA={activitiesData?.slice?.(0, 3) || []}
              title="News and Events"
              totalData={activitiesData || []}
            />
          </Box>
        </>
      )}
    </Box>
  )
}

export default Home
